<template>
    <div class="search">
        <div class="sound">
            <p class="title">Sound</p>
            <div class="input-wrapper">
                <label for="vibe">Vibe</label>
                <input
                    v-model="$v.userData.search.vibe.$model"
                    type="text"
                    class="vibe-input"
                    placeholder="Add Vibe"
                />
                <p
                    v-if="
                        $v.userData.search.vibe.$dirty &&
                        !$v.userData.search.vibe.correctFormat
                    "
                    class="error-msg"
                >
                    Please enter comma separated keywords.
                </p>
            </div>
        </div>
        <div class="where">
            <p class="title">Where</p>
            <div class="location-input-wrapper">
                <div class="address">
                    <label for="location">Locations</label>
                    <input
                        ref="autocomplete"
                        v-model="$v.userData.search.location.$model"
                        class="location-input"
                        type="text"
                        placeholder="Add Location"
                    />
                    <input type="hidden" v-model="$v.userData.search.lat.$model" />
                    <input type="hidden" v-model="$v.userData.search.lon.$model" />
                </div>
                <!-- <div class="radius">
                    <label for="radius">Distance</label>
                    <input
                        v-model="$v.userData.search.radius.$model"
                        class="radius-input"
                        type="number"
                        placeholder="0 miles"
                    />
                    <p
                        v-if="
                            $v.userData.search.radius.$dirty &&
                            !$v.userData.search.radius.minValue
                        "
                        class="error-msg"
                    >
                        Please enter at least 1 mile.
                    </p>
                </div> -->
            </div>
        </div>
    </div>
</template>
<script>
    import { minValue } from 'vuelidate/lib/validators'

    export default {
        name: 'Search',
        props: {
            userData: {
                type: Object,
                required: true
            },
            validation: {
                required: true
            }
        },
        emits: ['update:validation'],
        validations: {
            userData: {
                search: {
                    vibe: {
                        correctFormat: function (value) {
                            return (
                                !value ||
                                /^[&0-9a-zA-Z+\-_ ]+(,[&0-9a-zA-Z+\-_ ]+)*$/.test(value)
                            )
                        }
                    },
                    location: {},
                    lat: {},
                    lon: {},
                    radius: { minValue: minValue(1) }
                }
            }
        },
        watch: {
            $v: {
                handler: function (validation) {
                    this.$emit('update:validation', validation)
                },
                immediate: true
            },
            '$v.userData.search.location.$model': function (location) {
                if (location) {
                    this.$v.userData.search.lat.$touch()
                    this.$v.userData.search.lon.$touch()
                }
            }
        },
        mounted() {
            this.$nextTick(() => {
                if (this.$refs?.autocomplete) {
                    this.$emit('autocomplete-loaded', this.$refs.autocomplete)
                }
            })
        }
    }
</script>
<style lang="scss" scoped>
    @import '../../../../sass/_variables.scss';
    .search {
        p {
            margin-bottom: 0px;
        }
        button {
            border: none;
        }

        @include flex-start;
        width: 100%;
        flex-direction: column;
        justify-content: flex-start;
        gap: 24px;

        .sound,
        .where {
            @include flex-start;
            width: 100%;
            flex-direction: column;
            justify-content: flex-start;
            gap: 8px;

            .title {
                color: $lighter-grey;
                @include base-font-20;
                line-height: 120%;
                letter-spacing: -0.2px;
            }

            .location-input-wrapper {
                @include flex-start;
                width: 100%;
                flex-direction: row;
                justify-content: flex-start;
                gap: 8px;
            }
        }
        .input-wrapper,
        .address,
        .radius {
            @include flex-start;
            width: 100%;
            flex-direction: column;
            justify-content: flex-start;
        }
        label {
            padding: 4px 2px;
            color: $darker-grey;
            @include base-font-12;
            line-height: 135%;
            letter-spacing: 0.12px;
        }
        input {
            padding: 12px 16px 16px 16px;
            border-radius: 12px;
            border: 1px solid $darker-grey;
            background: $dark;
            overflow: hidden;
            color: $white;
            text-overflow: ellipsis;
            white-space: nowrap;
            @include base-font-16;
            font-weight: 550;
            line-height: 125%;
            align-self: stretch;
            width: 100%;
            -moz-appearance: textfield;
            appearance: textfield;
        }
        input::-webkit-outer-spin-button,
        input::-webkit-inner-spin-button {
            -webkit-appearance: none;
            margin: 0;
        }
        input::placeholder {
            overflow: hidden;
            color: $grey;
            text-overflow: ellipsis;
            @include base-font-16;
            line-height: 125%;
        }
        .address,
        .input-wrapper {
            width: 100%;
            max-width: 290px;
        }
        .radius {
            width: 100%;
            max-width: 80px;
        }
        .error-msg {
            color: $error;
            @include base-font-8;
            font-weight: 600;
            line-height: 130%;
            letter-spacing: 0.14px;
            text-wrap: nowrap;
        }
    }
</style>
